<template>
    <div class="w-100" style="background-color: #ffffff; border-bottom: 1px solid #ececec;">
        <header class="container">
            

            <nav class="main-navbar">
                <div class="navbar__logo align-self-center" style="text-align: left;">
                    <router-link class="navbar-brand" to="/" @click="handleNavClick(links[0])">
                        <img :src="require('@/assets/pawinhand_logo_v2.png')" class="img-logo"/>
                    </router-link>
                </div>
                
                <div class="navbar__open" :class="more_clicked ? 'active' : ''">

                    <ul class ="navbar__menu align-self-center">
                        <li v-for="menu in links" >
                            <router-link v-if="menu.title != '봉사관리' || (menu.title == '봉사관리' & $root.isAdmin)"
                                         v-show="menu.title != '소식관리' || ($root.shelter.popup_active == 'ON' || $root.shelter.shelter_news == 'ON')"
                                         :class="isMenuActive(menu) ? 'active' : ''" :to='menu.to' @click="handleNavClick()">{{menu.title}}</router-link>
                        </li>
                    </ul>

                    <ul class="navbar__icons">
                        <li>
                            <router-link class="navbar-brand" to='/setting' @click="deactivateMenu(); this.more_clicked = false;" style="margin-right: 0;">
                                <button type="button" class="btn position-relative">
                                    <i class="bi bi-gear" style="color:#333; font-size: 1.1rem; "></i>
                                </button> 
                            </router-link>
                        </li>
                        <!-- 확인 필요: 처리하면 사라지는 알림 (접종·신청서). 관리자 계정은 홈에서 보호소별로 -->
                        <!-- 보류 (2026-10-29): 헤더 확인 필요 버튼 숨김 — 다시 쓰려면 SHOW_HEADER_TODO = true (목록·입양관리 표시는 그대로) -->
                        <li v-if="SHOW_HEADER_TODO && !$root.isAdmin">
                            <button type="button" class="btn position-relative" id="todoButton" data-bs-toggle="dropdown" aria-expanded="false" title="확인 필요" @click="loadTodo(true)">
                                <i class="bi bi-clipboard-check" :style="{ color: todoTotal > 0 ? '#f6951c' : '#333', fontSize: '1.1rem' }"></i>
                                <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill todo-count-badge" v-if="todoTotal > 0">
                                    {{ todoTotal > 99 ? '99+' : todoTotal }}
                                </span>
                            </button>
                            <ul class="dropdown-menu dropdown-menu-end todo-dropdown" aria-labelledby="todoButton">
                                <li class="todo-dd-head">확인 필요</li>
                                <li v-for="t in TODO_TYPES" :key="t.key">
                                    <a class="dropdown-item todo-dd-item" href="#" @click.prevent="openTodo(t.key)">
                                        <i class="bi" :class="t.icon"></i>
                                        <span>{{ t.label }}</span>
                                        <b class="ms-auto" :class="todo.counts[t.key] ? 'fc-red' : 'fc-gray'">{{ todo.counts[t.key] || 0 }}</b>
                                        <i class="bi bi-chevron-right fc-gray"></i>
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li style="">
                            <!-- 알림: 최근 30일 · 탭(전체/입양신청/기타) · 열면 읽음 (읽음 기준 = 서버 SHELTER_ACCOUNT.ALARM_READ_IDX, 없으면 브라우저) -->
                            <button type="button" class="btn position-relative" id="alarmButton" ref="alarmBtn" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                                <i class="bi bi-bell" style="color:#333; font-size: 1.1rem;"></i>
                                <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" v-if="alarmCount > 0">
                                    {{alarmCount > 99 ? '99+' : alarmCount}}
                                    <span class="visually-hidden">안 읽은 알림</span>
                                </span>
                            </button>
                            <div class="dropdown-menu dropdown-menu-end alarm-panel" aria-labelledby="alarmButton">
                                <div class="ap-head">
                                    <b>알림</b>
                                    <button type="button" class="ap-refresh" title="새로고침" aria-label="알림 새로고침" @click="getAlarmList(true)"><i class="bi bi-arrow-clockwise"></i></button>
                                </div>
                                <div v-if="alarm_tab != 'today'" class="ap-note">이미 확인한 알림은 {{ READ_SHOW }}건까지만 보여요.</div>
                                <div class="ap-tabs" role="tablist">
                                    <button v-for="t in visibleTabs" :key="t.key" type="button" role="tab" :class="{ on: alarm_tab == t.key }" @click="alarm_tab = t.key">
                                        {{ t.label }}<span v-if="tabCount(t.key)" class="ap-tab-n">{{ tabCount(t.key) }}</span>
                                    </button>
                                </div>
                                <div v-if="alarm_tab == 'today'" class="ap-list">
                                    <a v-for="e in today_events" :key="e.type + (e.idx || e.notify_number) + e.title" href="#" class="ap-item ap-event" :class="{ done: e.done }" @click.prevent="eventClicked(e)">
                                        <span class="ap-ev-bar" :style="{ background: eventColor(e) }"></span>
                                        <span class="ap-body">
                                            <span class="ap-title">{{ eventText(e) }}</span>
                                            <span class="ap-meta"><span class="ap-ev-time">{{ e.time ? e.time + (e.end_time ? ' ~ ' + e.end_time : '') : '종일' }}</span><span class="ap-state" :style="{ color: eventColor(e) }">{{ eventLabel(e) }}</span><span v-if="e.done" class="ap-state">완료</span></span>
                                        </span>
                                    </a>
                                    <div v-if="!today_events.length" class="ap-empty">오늘 일정이 없습니다.</div>
                                </div>
                                <div v-else class="ap-list">
                                    <a v-for="alarm in tabAlarms" :key="alarm.key" href="#" class="ap-item" :class="{ unread: isUnread(alarm, true) }" @click.prevent="alarmClicked(alarm)">
                                        <span class="ap-icon" :class="'t-' + alarmKind(alarm)"><i class="bi" :class="alarmIcon(alarm)"></i></span>
                                        <span class="ap-body">
                                            <span class="ap-title">{{ alarm.title }}</span>
                                            <span v-if="alarm.sub" class="ap-sub-line">{{ alarm.sub }}</span>
                                            <span class="ap-meta"><span v-if="alarm.who" class="ap-who">{{ alarm.who }}</span>{{ timeAgo(alarm.w_date) }}<span v-if="alarm.request_state" class="ap-state" :class="'s-' + alarm.request_state">{{ alarm.request_state }}</span></span>
                                        </span>
                                        <span v-if="isUnread(alarm, true)" class="ap-dot" aria-label="안 읽음"></span>
                                    </a>
                                    <div v-if="!tabAlarms.length" class="ap-empty">{{ alarm_loading ? '불러오는 중…' : '알림이 없습니다.' }}</div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    
                </div>

                <a class="navbar__toogleBtn" @click="more_clicked = !more_clicked">
                    <i class="bi bi-list"></i>    
                </a>
            </nav>  
        </header>
    </div>
</template>

<script>
import 'bootstrap/dist/js/bootstrap.esm.min.js'
import { todoState, TODO_MODAL_TYPES as TODO_TYPES, loadTodo } from '@/utils/todoStore'
import moment from 'moment'
import { scheduleColor, scheduleTypeLabel } from '@/utils/scheduleStore'
//알림 창에 보이는 최소 개수 (읽은 알림 포함, 안 읽은 게 더 많으면 그만큼)
const READ_SHOW = 20;
//알림 출처 탭 (전체 = 이 탭들 모두)
const ALARM_SOURCE_TABS = ['adopt', 'etc'];

export default {
    name: 'Header',
    data(){
        return {
            shelter : {},

            links: [
                { title: '홈',    to: '/'        },
                // { title: '신고관리', to: '/report' },
                { title: '동물관리', to: '/animal'   },
                // { title: '진료관리', to: '/treatment' },
                // { title: '봉사관리', to: '/volunteer' },
                { title: '입양관리', to: '/adoption' },
                { title: '소식관리', to: '/news'     },
            ],
            alarmOpen : false,
            alarmList : [],
            alarmCount : 0,
            reads : {},             //탭별 마지막 확인 시각 (서버 SHELTER_ALARM_READ · 브라우저 중 늦은 값)
            view_reads : {},        //이번에 연 창에서 '안 읽음' 표시 기준 (열 때의 값 — 읽음 처리 뒤에도 방금 온 알림 표시 유지)
            alarm_baseline : '',    //확인 기록이 없는 탭: 최근 하루만 안 읽음으로
            alarm_tab : 'all',
            alarm_open_handled : false,
            alarm_opened_at : 0,
            alarm_loading : false,
            alarm_loaded_at : 0,
            alarm_timer : null,
            ALARM_DAYS : 30,
            READ_SHOW,
            ALARM_TABS : [{ key: 'all', label: '전체' }, { key: 'adopt', label: '입양신청' }, { key: 'today', label: '오늘 일정' }, { key: 'etc', label: '기타' }],
            today_events : [],      //오늘 일정 탭 (/shelter/schedule 오늘 하루, 읽음·뱃지와 무관)
            more_clicked : false,
            todo : todoState,
            SHOW_HEADER_TODO: false,
            TODO_TYPES,
        }
    },
    methods: {
        handleNavClick() {
            this.more_clicked = false;
        },
        deactivateMenu(){},

        isMenuActive(menu) {
            if (menu.to === '/') return this.$route.path === '/';
            return this.$route.path.startsWith(menu.to);
        },

        //알림 (최근 30일: 입양신청·댓글·후기·기타) — 화면 가리는 로딩 없이 조용히. 페이지 이동·2분마다(탭이 보일 때만) 다시
        getAlarmList(force){
            if (!this.shelter || !this.shelter.shelter_device_number) return;
            if (!force && Date.now() - this.alarm_loaded_at < 60 * 1000) return;
            if (!force && typeof document !== 'undefined' && document.hidden) return;
            this.alarm_loaded_at = Date.now();
            this.alarm_loading = true;
            this.loadTodayEvents();
            this.axios.get(`/alarm/v2`, { params: { email: this.shelter.shelter_device_number, days: this.ALARM_DAYS, force: !!force } })
            .then(res => {
                const d = res.data || {};
                this.alarmList = Array.isArray(d.items) ? d.items : [];
                if (!this.alarm_baseline) this.alarm_baseline = moment(d.now || undefined).subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss');
                //확인 시각: 서버 값과 이 브라우저 값 중 늦은 것 (서버 저장 실패·리플리카 지연 대비)
                const local = this.localReads(), server = d.reads || {}, merged = {};
                ALARM_SOURCE_TABS.forEach(t => { const a = server[t] || '', b = local[t] || ''; const v = a > b ? a : b; if (v) merged[t] = v; });
                this.reads = merged;
                if (!this.isAlarmOpen()) this.view_reads = { ...merged };
                this.alarmCount = this.alarmList.filter(a => this.isUnread(a, false)).length;
            })
            .catch(e => console.log(e))
            .finally(() => { this.alarm_loading = false; });
        },
        alarmStoreKey(){ return 'pasm_alarm_reads_' + (this.shelter && this.shelter.shelter_device_number || ''); },
        localReads(){
            try { return JSON.parse(localStorage.getItem(this.alarmStoreKey()) || '{}') || {}; } catch (e) { return {}; }
        },
        readAtOf(tab, src){ return src[tab] || this.alarm_baseline; },
        //안 읽음 = 확인 시각보다 늦게 생긴 알림 (view: 이번에 연 창의 표시 기준)
        isUnread(a, view){ return String(a.w_date || '') > this.readAtOf(a.tab, view ? this.view_reads : this.reads); },
        isAlarmOpen(){
            const b = this.$refs.alarmBtn;
            return !!(b && b.getAttribute('aria-expanded') === 'true');
        },
        tabsOf(key){ return key == 'all' ? ALARM_SOURCE_TABS : [key]; },
        tabFilter(key){
            if (key == 'all') return () => true;
            return a => a.tab == key;
        },
        //탭 옆 숫자: 안 읽은 알림 수만 (0이면 숨김)
        tabCount(key){
            if (key == 'today') return this.today_events.filter(e => !e.done).length;
            return this.alarmList.filter(this.tabFilter(key)).filter(a => this.isUnread(a, true)).length;
        },
        //오늘 일정 (홈 요약과 같은 API) — 알림 불러올 때·창 열 때
        loadTodayEvents(){
            if (!this.shelter || !this.shelter.shelter_device_number) return;
            const today = moment().format('YYYY-MM-DD');
            this.axios.get(`/shelter/schedule`, { params: { start: today, end: today, shelter_device_number: this.shelter.shelter_device_number } })
                .then(res => { this.today_events = ((res.data && res.data.events) || []).slice().sort((a, b) => String(a.time || '').localeCompare(String(b.time || ''))); })
                .catch(() => {});
        },
        eventColor(e){ return scheduleColor(e); },
        eventLabel(e){ return scheduleTypeLabel(e); },
        eventText(e){
            const animal = e.animal_name || '';
            if (e.type == 'vaccine' || e.type == 'kit') return (animal ? animal + ' ' : '') + (e.title || '');
            return e.title || '';
        },
        //일정 누르면 홈 캘린더 오늘(일 보기)로
        eventClicked(){
            if (this.isAlarmOpen() && this.$refs.alarmBtn) this.$refs.alarmBtn.click();
            const go = () => this.emitter.emit('homeCalendarGoDay', { date: moment().format('YYYY-MM-DD') });
            if (this.$route.path === '/') go();
            else this.$router.push('/').then(() => setTimeout(go, 400));
        },
        //보고 있는 탭(전체면 모든 탭)을 확인 처리 — 가장 늦은 알림 시각까지
        markRead(key){
            const tabs = this.tabsOf(key), changed = [];
            let at = '';
            tabs.forEach(t => {
                const latest = this.alarmList.filter(a => a.tab == t).reduce((m, a) => (String(a.w_date) > m ? String(a.w_date) : m), '');
                if (latest && latest > (this.reads[t] || '')) { this.reads = { ...this.reads, [t]: latest }; changed.push(t); if (latest > at) at = latest; }
            });
            this.alarmCount = this.alarmList.filter(a => this.isUnread(a, false)).length;
            if (!changed.length) return;
            try { localStorage.setItem(this.alarmStoreKey(), JSON.stringify(this.reads)); } catch (e) { /* noop */ }
            const fd = new FormData();
            fd.append('email', this.shelter.shelter_device_number);
            fd.append('tab', changed.join(','));
            fd.append('read_at', at);
            this.axios.put('/alarm/read', fd).catch(() => {});
        },
        alarmKind(a){
            if (a.tab == 'adopt') return 'adopt';
            return a.type == 'message' ? 'msg' : 'etc';
        },
        alarmIcon(a){
            return { adopt_request: 'bi-file-earmark-text', request_state: 'bi-arrow-repeat', message: 'bi-envelope', following: 'bi-person-plus' }[a.type] || 'bi-bell';
        },
        timeAgo(w){
            const t = moment(w, 'YYYY-MM-DD HH:mm:ss');
            if (!t.isValid()) return w || '';
            const m = moment().diff(t, 'minutes');
            if (m < 1) return '방금';
            if (m < 60) return m + '분 전';
            if (m < 60 * 24) return Math.floor(m / 60) + '시간 전';
            if (m < 60 * 24 * 7) return Math.floor(m / 1440) + '일 전';
            return t.format('M월 D일');
        },

        //확인 필요: 페이지 이동 때마다(30초 안에는 다시 안 부름), 관련 저장 뒤에는 바로
        loadTodo(force){
            if (this.$root.isAdmin || !this.shelter || !this.shelter.shelter_device_number) return;
            loadTodo(this.axios, this.shelter.shelter_device_number, force);
        },
        refreshTodo(){
            this.loadTodo(true);
        },
        openTodo(type){
            this.more_clicked = false;
            this.emitter.emit('openTodoModal', { type });
        },

        //종을 열면: 이번 창에는 열 때 기준으로 안 읽음 표시를 남기고, 뱃지는 바로 0 + 읽음 기준 저장 (서버 + 브라우저)
        //(부트스트랩 'shown.bs.dropdown' — 창이 실제로 열린 뒤) 이번 창 표시 기준을 남기고, 보고 있는 탭을 확인 처리
        readAlarm(){
            //부트스트랩이 두 번 불려(main.js·헤더) 열림·닫힘 이벤트가 겹쳐 오므로 열고 1.5초 안의 중복은 무시
            if (this.alarm_open_handled && Date.now() - this.alarm_opened_at < 1500) return;
            this.alarm_open_handled = true;
            this.alarm_opened_at = Date.now();
            this.view_reads = { ...this.reads };
            this.markRead(this.alarm_tab);
            this.loadTodayEvents();
        },
        //창을 닫으면 다음에 열 때는 확인한 상태로 보이게
        onAlarmHidden(){
            if (Date.now() - this.alarm_opened_at < 1500) return;   //열자마자 겹쳐 오는 닫힘 이벤트
            this.alarm_open_handled = false;
            this.view_reads = { ...this.reads };
        },

        alarmClicked(alarm){
            //창 닫기
            if (this.isAlarmOpen() && this.$refs.alarmBtn) this.$refs.alarmBtn.click();
            switch(alarm.type){
                case 'adopt_request' :
                case 'request_state' : {
                    //그 신청서 상세 바로 열기 (입양관리가 ?request= 를 보고 엶)
                    this.handleNavClick();
                    if (alarm.ref_idx) this.$router.push({ path: '/adoption', query: { request: String(alarm.ref_idx) } });
                    else this.$router.push('/adoption');
                    break;
                }
                default:
                    break;
            }
        }

    },
    mounted(){
        this.shelter = this.$root.shelter;
        this.getAlarmList(true);
        this.alarm_timer = setInterval(() => this.getAlarmList(true), 2 * 60 * 1000);
        if (this.$refs.alarmBtn) {
            this.$refs.alarmBtn.addEventListener('shown.bs.dropdown', this.readAlarm);
            this.$refs.alarmBtn.addEventListener('hidden.bs.dropdown', this.onAlarmHidden);
        }
        this.loadTodo(true);
        //접종 기록 저장 뒤 확인 필요 다시 계산 ('refreshAdoptRequest'·'refreshAnimalList' 는 각 화면이 off(이름)로 모든 구독을 지워서 못 씀 → 페이지 이동·드롭다운 열 때 갱신)
        ['refreshTodo', 'animalVaccinationChanged'].forEach(e => this.emitter.on(e, this.refreshTodo));
        this.emitter.on('scheduleChanged', this.loadTodayEvents);
    },
    beforeUnmount(){
        if (this.alarm_timer) clearInterval(this.alarm_timer);
        if (this.$refs.alarmBtn) {
            this.$refs.alarmBtn.removeEventListener('shown.bs.dropdown', this.readAlarm);
            this.$refs.alarmBtn.removeEventListener('hidden.bs.dropdown', this.onAlarmHidden);
        }
        ['refreshTodo', 'animalVaccinationChanged'].forEach(e => this.emitter.off(e, this.refreshTodo));
        this.emitter.off('scheduleChanged', this.loadTodayEvents);
    },
    computed: {
        //탭 목록 (최신순): 최근 20개까지는 읽었어도 표시(회색), 안 읽은 게 20개보다 많으면 안 읽은 것 전부
        tabAlarms(){
            const list = this.alarmList.filter(this.tabFilter(this.alarm_tab));
            const unread = list.filter(a => this.isUnread(a, true)).length;
            return list.slice(0, Math.max(READ_SHOW, unread));
        },
        //'기타'(쪽지·팔로우)는 있을 때만 탭으로
        visibleTabs(){
            return this.ALARM_TABS.filter(t => t.key != 'etc' || this.alarmList.some(a => a.tab == 'etc'));
        },
        //헤더 뱃지 = 확인 필요 창에 보이는 종류만 (접종)
        todoTotal(){
            return TODO_TYPES.reduce((n, t) => n + (this.todo.counts[t.key] || 0), 0);
        },
    },
    watch: {
        '$route.path'(){
            this.loadTodo(false);
            this.getAlarmList(false);
        },
        //창이 열린 채로 탭을 바꾸면 그 탭을 확인 처리 (표시 기준은 열 때 그대로)
        alarm_tab(key){
            if (this.isAlarmOpen()) this.markRead(key);
        },
    }

}
</script>

<style scoped>
    @import '@/assets/css/header/style.css';

    a{text-decoration:none; color:#333;}

    .todo-count-badge { background: #f6951c; }
    /* 헤더 알림 창 */
    .alarm-panel { width: 380px; max-width: calc(100vw - 24px); padding: 0; border-radius: 12px; border: 1px solid #eee; box-shadow: 0 8px 28px rgba(0,0,0,.14); overflow: hidden; }
    .ap-head { display: flex; align-items: center; gap: 8px; padding: 14px 16px 10px; }
    .ap-head b { font-size: 16px; color: #222; }
    .ap-note { padding: 0 16px 8px; margin-top: -4px; font-size: 12px; color: #999; }
    .ap-refresh { margin-left: auto; border: 0; background: transparent; color: #888; font-size: 16px; padding: 2px 4px; cursor: pointer; }
    .ap-refresh:hover { color: #f6951c; }
    .ap-tabs { display: flex; gap: 4px; padding: 0 12px 8px; border-bottom: 1px solid #f0f0f0; }
    .ap-tabs button { border: 0; background: transparent; padding: 5px 11px; border-radius: 14px; font-size: 13px !important; font-weight: 600; color: #777; cursor: pointer; line-height: 1.4; }
    .ap-tabs button.on { background: #FFF1DF; color: #E07F05; }
    .ap-tab-n { margin-left: 4px; font-size: 12px !important; opacity: .8; }
    .ap-list { max-height: 420px; overflow-y: auto; }
    .ap-item { display: flex; align-items: flex-start; gap: 10px; padding: 11px 16px; border-bottom: 1px solid #f6f6f6; color: #9a9a9a; text-decoration: none; }
    .ap-item:not(.unread) .ap-title { color: #9a9a9a; font-weight: 400; }
    .ap-item:not(.unread) .ap-state { opacity: .7; }
    .ap-item.unread .ap-title { font-weight: 600; }
    .ap-item:hover { background: #FAFAFA; }
    .ap-item.unread { color: #222; background: #FFFBF5; }
    .ap-item.unread:hover { background: #FFF6EA; }
    .ap-icon { flex: 0 0 30px; height: 30px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 14px; background: #F2F2F2; color: #888; }
    .ap-item.unread .ap-icon.t-adopt { background: #FFF1DF; color: #E07F05; }
    .ap-item.unread .ap-icon.t-msg { background: #E8EEFD; color: #3B6FE0; }
    .ap-event { align-items: stretch; color: #222; }
    .ap-event.done { color: #aaa; }
    .ap-event.done .ap-title { text-decoration: line-through; }
    .ap-ev-bar { flex: 0 0 4px; border-radius: 2px; }
    .ap-ev-time { color: #555; font-weight: 600; font-variant-numeric: tabular-nums; }
    .ap-event .ap-state { background: #F4F4F5; }
    .ap-sub-line { font-size: 12.5px; color: #888; line-height: 1.45; white-space: normal; word-break: break-all; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
    .ap-item:not(.unread) .ap-sub-line { color: #b0b0b0; }
    .ap-body { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 3px; }
    .ap-title { font-size: 13.5px; line-height: 1.45; white-space: normal; word-break: keep-all; }
    .ap-meta { font-size: 12px; color: #aaa; display: flex; align-items: center; gap: 6px; }
    .ap-who { color: #666; font-weight: 600; }
    .ap-who::after { content: '·'; margin-left: 6px; color: #ccc; font-weight: 400; }
    .ap-item:not(.unread) .ap-who { color: #aaa; }
    .ap-state { font-size: 11px; font-weight: 700; padding: 1px 7px; border-radius: 9px; background: #F0F0F0; color: #777; }
    .ap-state.s-대기중 { background: #FFF6D6; color: #A27A00; }
    .ap-state.s-상담중 { background: #E3EDFF; color: #2F64D6; }
    .ap-state.s-입양완료 { background: #FFEBD3; color: #D9750B; }
    .ap-dot { flex: 0 0 7px; height: 7px; margin-top: 7px; border-radius: 50%; background: #F04438; }
    .ap-empty { padding: 36px 16px; text-align: center; font-size: 13px; color: #aaa; }
    .todo-dropdown { min-width: 250px; padding: 6px 0; }
    .todo-dd-head { font-weight: 700; font-size: 13px; color: #333; padding: 4px 14px 6px; border-bottom: 1px solid #f0f0f0; margin-bottom: 4px; }
    .todo-dd-item { display: flex !important; align-items: center; gap: 8px; font-size: 13.5px; padding: 7px 14px; }
    .todo-dd-item .bi-chevron-right { font-size: 11px; }
    .fc-red { color: #E53935; }

    @media (max-width: 768px) {
        .container{
            padding-left: 0 !important;
            padding-right: 0 !important;
        }
        /* 펼친 메뉴: 줄 전체를 눌러 이동, 아래 그림자로 본문과 구분 */
        .navbar__open.active { box-shadow: 0 8px 16px rgba(0, 0, 0, .08); border-bottom: 1px solid #ececec; }
        .navbar__menu li a { display: block; padding: 12px 0; font-size: 16px; }
        .navbar__icons .btn { min-width: 44px; min-height: 44px; }
        .navbar__toogleBtn { padding: 8px 12px; font-size: 24px; }
        .todo-dropdown, .navbar__icons .dropdown-menu { max-width: calc(100vw - 16px); }
        .navbar__icons .dropdown-menu .dropdown-item { white-space: normal; padding-top: 10px; padding-bottom: 10px; }
    }
</style>